<template>
  <div
    class="page--company-group"
    :style="`min-height: ${height}px`"
  >
    <Header
      :kind="routeParams.type"
      :status="currentStatus"
      :showErrorMessage="headerErrorMessage"
      @hideErrorMessage="handleHeaderErrorMessage(false)"
    />

    <Form
      :kind="routeParams.type"
      :submit="submitForm"
      :data="companyGroupData"
      :status="currentStatus"
      @tryAgain="getCompanyGroupById"
      @setCurrentStatus="setCurrentStatus"
      @headerErrorMessage="handleHeaderErrorMessage"
    />

    <Footer
      :kind="routeParams.type"
      :status="currentStatus"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { mapActions } from 'vuex'
import { isArray, isObject } from 'utils/functions'
import Header from 'components/companyGroup/Header'
import Form from 'components/companyGroup/Form'
import Footer from 'components/companyGroup/Footer'

export default {
  name: 'CompanyGroupPage',
  components: {
    Header,
    Form,
    Footer
  },
  computed: {
    routeParams () {
      return this.$route.params
    },

    height () {
      return document.body.offsetHeight
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyGroupPage',
      submitForm: false,
      companyGroupData: null,
      currentStatus: null,
      headerErrorMessage: false
    }
  },
  methods: {
    ...mapActions({
      errorAlert: 'snackbarAlert/error'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    isValidObject (val) {
      return isObject(val)
    },

    handleSubmit () {
      this.submitForm = !this.submitForm
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    },

    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    },

    handleHeaderErrorMessage (val) {
      this.headerErrorMessage = val
    },

    async getCompanyGroupById () {
      if (this.routeParams.type === 'editar') {
        this.currentStatus = STATUS_IS_LOADING

        try {
          const companyGroupId = Number(this.routeParams.id)
          const { data: res } = await this.$apiService.companyGroup.get({
            groupId: companyGroupId
          })

          if (!this.isValidArray(res.data) || !this.isValidObject(res.data[0])) {
            throw new Error(JSON.stringify(res))
          }

          this.companyGroupData = res.data[0]
          this.currentStatus = STATUS_SUCCESS
        } catch (err) {
          console.log('ERROR', err)
          this.currentStatus = STATUS_FAILED
          this.errorAlert(this.$t('Messages.genericError'))
        }
      }
    }
  },
  watch: {
    'routeParams.id' () {
      location.reload()
    }
  },
  beforeMount () {
    if (this.routeParams.type !== 'cadastrar' && this.routeParams.type !== 'editar') {
      this.$router.push({ name: 'Company' })
    }
  },
  mounted () {
    this.getCompanyGroupById()

    if (this.routeParams.type !== 'editar') {
      this.currentStatus = STATUS_SUCCESS
    }

    this.setChatPosition('75px', '10px')
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>
